import { api } from 'app/config/apiConfig';
import { WaitingListEntry } from '../model/types';

export const deleteWaitingListEntryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    deleteWaitingListEntry: builder.mutation<WaitingListEntry, string>({
      query: (waitingListEntryId: string) => ({
        url: `/waiting-list-entry/${waitingListEntryId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Waiting list'],
    }),
  }),
});

export const { useDeleteWaitingListEntryMutation } = deleteWaitingListEntryApi;
